import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { className: "tabs" }

import { isBefore, isEqual, isAfter } from 'date-fns';
import { ref, watch } from 'vue';
import { refundUrl } from '../../envVariables';
import { RteContentType, SailingStatusType } from '../../types';
import {
  SailingTabView,
  ServiceTabView,
  InformationTabView,
  Tabs,
  Tab,
} from '../../index';
import { RouteStatus, StatusCategory } from '../../apiTypes';
import { WarningCard } from '../../Molecules';


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceStatusTabs',
  props: {
    sailingStatusReports: {},
    serviceStatuses: {},
    informationStatuses: {},
    routeStatuses: {},
    onFindAlternateClick: { type: Function },
    initialTab: {}
  },
  emits: ['tabChange'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const onTabChange = (tab: string) => {
  emit('tabChange', tab);
};

const warningCardDetails = ref<RouteStatus>();
const showWarningMessage = ref(false);

const onRefundClick = () => {
  window.open(refundUrl);
};

watch(() => props.routeStatuses, (statuses) => {
  if (!statuses) {
    warningCardDetails.value = undefined;
    showWarningMessage.value = false;
    return;
  }

  const warningDetails = statuses.find((x) => x.status === StatusCategory.Warning);
  if (!warningDetails) {
    warningCardDetails.value = undefined;
    showWarningMessage.value = false;
    return;
  }

  warningCardDetails.value = warningDetails;
  showWarningMessage.value = (
    isBefore(
      new Date(warningDetails.startDateTime).setHours(0, 0, 0, 0),
      new Date().setHours(0, 0, 0, 0),
    ) || isEqual(
      new Date(warningDetails.startDateTime).setHours(0, 0, 0, 0),
      new Date().setHours(0, 0, 0, 0),
    )
  )
    && (
      isAfter(
        new Date(warningDetails.endDateTime).setHours(0, 0, 0, 0),
        new Date().setHours(0, 0, 0, 0),
      ) || isEqual(
        new Date(warningDetails.endDateTime).setHours(0, 0, 0, 0),
        new Date().setHours(0, 0, 0, 0),
      )
    );
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Tabs), {
      "initial-tab": props.initialTab,
      onTabChange: onTabChange
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Tab), {
          title: _ctx.$t('Sailings')
        }, {
          default: _withCtx(() => [
            (showWarningMessage.value && warningCardDetails.value)
              ? (_openBlock(), _createBlock(_unref(WarningCard), {
                  key: 0,
                  title: warningCardDetails.value.title,
                  text: warningCardDetails.value.detail
                }, null, 8, ["title", "text"]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sailingStatusReports, (item, i) => {
              return (_openBlock(), _createBlock(_unref(SailingTabView), {
                key: i,
                status: item.status,
                "status-heading": item.statusHeading ?? _ctx.$t('Service normal'),
                "rte-content": item.rteContent,
                "find-alternative-click": _ctx.onFindAlternateClick,
                "refund-click": () => onRefundClick(),
                "show-alternative-cta": item.showAlternativeCta,
                "show-refund-cta": item.showRefundCta
              }, null, 8, ["status", "status-heading", "rte-content", "find-alternative-click", "refund-click", "show-alternative-cta", "show-refund-cta"]))
            }), 128)),
            _renderSlot(_ctx.$slots, "liveUpdatesInfoCard")
          ]),
          _: 3
        }, 8, ["title"]),
        _createVNode(_unref(Tab), {
          title: _ctx.$t('Service')
        }, {
          default: _withCtx(() => [
            (showWarningMessage.value && warningCardDetails.value)
              ? (_openBlock(), _createBlock(_unref(WarningCard), {
                  key: 0,
                  title: warningCardDetails.value.title,
                  text: warningCardDetails.value.detail
                }, null, 8, ["title", "text"]))
              : _createCommentVNode("", true),
            _createVNode(_unref(ServiceTabView), {
              heading: _ctx.$t('Service'),
              "is-empty": 
            _ctx.serviceStatuses == undefined || _ctx.serviceStatuses.length === 0
          ,
              "rte-content": _ctx.serviceStatuses
            }, null, 8, ["heading", "is-empty", "rte-content"]),
            _renderSlot(_ctx.$slots, "liveUpdatesInfoCard")
          ]),
          _: 3
        }, 8, ["title"]),
        _createVNode(_unref(Tab), {
          title: _ctx.$t('Information')
        }, {
          default: _withCtx(() => [
            (showWarningMessage.value && warningCardDetails.value)
              ? (_openBlock(), _createBlock(_unref(WarningCard), {
                  key: 0,
                  title: warningCardDetails.value.title,
                  text: warningCardDetails.value.detail
                }, null, 8, ["title", "text"]))
              : _createCommentVNode("", true),
            _createVNode(_unref(InformationTabView), {
              heading: _ctx.$t('Information'),
              "rte-content": _ctx.informationStatuses,
              "is-empty": 
            _ctx.informationStatuses == undefined || _ctx.informationStatuses.length === 0
          
            }, null, 8, ["heading", "rte-content", "is-empty"]),
            _renderSlot(_ctx.$slots, "liveUpdatesInfoCard")
          ]),
          _: 3
        }, 8, ["title"])
      ]),
      _: 3
    }, 8, ["initial-tab"])
  ]))
}
}

})